// extracted by mini-css-extract-plugin
export default {"box":"NotFound_box__Q54DW","content":"NotFound_content__WreKK"};